import type { FlightSearchFormLabels } from "../../labels";
import type { PassengersControl } from "../../use-passengers";

import { passengersInputLabel } from "./label";
import { PassengersInputMobile } from "./passengers-input-mobile";
import { PassengersInputDesktop } from "./passengers-input-desktop";

export type PassengersInputProperties = {
  controlAdults: PassengersControl;
  controlChildren: PassengersControl;
  controlInfants: PassengersControl;
  labels: FlightSearchFormLabels["passengersDropdown"];
};
export const PassengersInput = ({
  controlAdults,
  controlChildren,
  controlInfants,
  labels,
}: PassengersInputProperties) => {
  const passengersButtonLabel = passengersInputLabel({
    adultsCount: controlAdults.value,
    childrenCount: controlChildren.value,
    infantsCount: controlInfants.value,
    labels,
  });

  return (
    <>
      <input
        className="hidden"
        name="adults"
        readOnly
        type="number"
        value={controlAdults.value}
      />
      <input
        className="hidden"
        name="children"
        readOnly
        type="number"
        value={controlChildren.value}
      />
      <input
        className="hidden"
        name="infants"
        readOnly
        type="number"
        value={controlInfants.value}
      />

      <div className="text-left md:hidden">
        <PassengersInputMobile
          controlAdults={controlAdults}
          controlChildren={controlChildren}
          controlInfants={controlInfants}
          labels={labels}
          passengersButtonLabel={passengersButtonLabel}
        />
      </div>
      {/* Desktop View */}
      <div className="max-md:hidden md:contents">
        <PassengersInputDesktop
          controlAdults={controlAdults}
          controlChildren={controlChildren}
          controlInfants={controlInfants}
          labels={labels}
          passengersButtonLabel={passengersButtonLabel}
        />
      </div>
    </>
  );
};
